/**
 * Initializes one product shelf carousel.
 * @param {HTMLElement} section
 */
function initializeProductsShelf(section) {
  if (section.dataset.initialized === 'true') return;

  const swiperElement = section.querySelector('[data-products-shelf-swiper]');
  if (!(swiperElement instanceof HTMLElement) || typeof window.Swiper !== 'function') return;

  section.dataset.initialized = 'true';
  section.productsShelfSwiper = new window.Swiper(swiperElement, {
    slidesPerView: 1.3,
    spaceBetween: 10,
    loop: section.dataset.loop === 'true',
    watchOverflow: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      enabled: true,
    },
    navigation: {
      nextEl: section.querySelector('[data-products-shelf-next]'),
      prevEl: section.querySelector('[data-products-shelf-prev]'),
    },
    breakpoints: {
      480: {
        slidesPerView: 2.3,
      },
      750: {
        slidesPerView: 3,
      },
      994: {
        slidesPerView: 5,
      },
    },
  });
}

function initializeProductsShelves(scope = document) {
  scope.querySelectorAll('[data-products-shelf]').forEach((section) => {
    if (section instanceof HTMLElement) initializeProductsShelf(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeProductsShelves(), { once: true });
} else {
  initializeProductsShelves();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) initializeProductsShelves(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target instanceof Element ? event.target.querySelector('[data-products-shelf]') : null;
  section?.productsShelfSwiper?.destroy(true, true);
});
